import React, { Component } from "react"
import {
  Segment,
  Form,
  Dropdown,
  Button,
  Input,
  Label,
  Icon
} from "semantic-ui-react"
import { translate } from "react-translate"
import "./EditionParametrePiedDePage.css"
import _ from "lodash"

const optionsGarantie = [
  { key: "axa", text: "value_dropdown_axa", value: "axa" },
  { key: "macif", text: "value_dropdown_macif", value: "macif" },
  { key: "matmut", text: "value_dropdown_matmut", value: "matmut" },
  { key: "alianz", text: "value_dropdown_alianz", value: "alianz" }
]

const optionsImmatriculation = [
  { key: "choix1", text: "value_dropdown_choix1", value: "choix1" },
  { key: "choix2", text: "value_dropdown_choix2", value: "choix2" },
  { key: "choix3", text: "value_dropdown_choix3", value: "choix3" }
]

class EditionParametrePiedDePage extends Component {
  constructor(props) {
    super(props)
  }

  componentWillMount() {
    let { t } = this.props
    var optionsGarantieCopy = _.clone(optionsGarantie)
    optionsGarantieCopy = _.map(optionsGarantieCopy, x => {
      return {
        ...x,
        text: t(x.text)
      }
    })
    var optionsImmatriculationCopy = _.clone(optionsImmatriculation)
    optionsImmatriculationCopy = _.map(optionsImmatriculationCopy, x => {
      return {
        ...x,
        text: t(x.text)
      }
    })

    this.setState({
      optionsGarantie: optionsGarantieCopy,
      optionsImmatriculation: optionsImmatriculationCopy
    })
  }

  render() {
    let { t } = this.props
    return (
      <Segment id="blocPiedDePage">

        <Segment.Group id="premierBlocForm" horizontal>

        <Segment id="premierBlocFormPiedDePage">

        <Form>
        <Segment.Group horizontal className="sectionPiedDePage">
          <Segment>
              <Form.Field id="inputNumeroTVA">
                <label>{t("input_label_identification")}</label>
                <input
                  id="champInput"
                  placeholder={t("placeholder_identification")}
                />
              </Form.Field>
            </Segment>
            <Segment>
              <Form.Field id="inputFormeJuridique">
                <label>{t("input_label_juridique")}</label>
                <input id="champInput" placeholder={t("placeholder_juridique")} />
              </Form.Field>
              </Segment>
              <Segment>
                <Form.Field id="inputCapitalSocial">
                  <label>{t("input_label_social")}</label>
                  <Input
                    id="inputChampCapitalSocial"
                    labelPosition="right"
                    type="text"
                  >
                    <input />
                    <Label id="inputCapitalSocialCurrency">€</Label>
                  </Input>
                </Form.Field>
              </Segment>
            </Segment.Group>

            <Segment.Group horizontal className="sectionPiedDePage">
              <Segment>
                <Form.Field id="inputImmatriculation">
                  <label id="labelJuridique">
                    {t("input_label_immatriculation")}
                  </label>
                  <Dropdown
                    id="dropdownJuridique"
                    placeholder={t("placeholder_immatriculation")}
                    fluid
                    selection
                    options={this.state.optionsImmatriculation || []}
                  />
                </Form.Field>
                </Segment>
                <Segment>
                <Form.Field id="inputImmatriculation2">
                  <label id="labelJuridique">
                    &nbsp;
                  </label>
                  <input
                    id="champInput"
                    placeholder={t("placeholder_input_immatriculation")}
                  />
                </Form.Field>
              </Segment>
            </Segment.Group>

            <Segment.Group horizontal className="sectionPiedDePage">
              <Segment>

                <Form.Field id="inputGarantie">
                  <label id="labelJuridique">{t("input_label_garantie")}</label>
                  <Dropdown
                    id="dropdownJuridique"
                    placeholder={t("placeholder_garantie")}
                    fluid
                    selection
                    options={this.state.optionsGarantie || []}
                  />
                </Form.Field>
              </Segment>
            <Segment>
            <Form.Field id="inputGarantie2">
              <label id="labelJuridique">
                &nbsp;
              </label>
              <input
                id="champInput"
                placeholder={t("placeholder_input_garantie")}
              />
            </Form.Field>
            </Segment>
            </Segment.Group>
          </Form>
        </Segment>
        <Segment id="secondBlocFormPiedDePage">
          <label>{t("title_block_pied")}</label>
          <Button id="btnLock">
            <Icon id="lockIcon" name="lock" link />
            {t("title_button_pied")}
          </Button>

          <Segment id="blocEnteteParDefaut">
            <p id="textParDefaut">
              abdelbast annomany - 357 Lotissement Assafsaf,
              <br />
              Marrakech, 40000 Marrakech, Maroc
              <br />
              e-mail : annomanyabdelbast@gmail.com - SARL
            </p>
          </Segment>
        </Segment>

        </Segment.Group>

      </Segment>
    )
  }
}

export default translate("ProParamFooter")(EditionParametrePiedDePage)



// WEBPACK FOOTER //
// ./src/components/Pro/Parametres/PiedDePage/EditionParametrePiedDePage.js